// This file is auto-generated by @hey-api/openapi-ts

export enum CallStatus {
  DIALING = 'dialing',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  FAILED = 'failed'
}

export enum CallMode {
  PHONE = 'phone',
  BROWSER = 'browser'
}

export enum Language {
  EN = 'en',
  DE = 'de'
}

export enum Unit {
  PIECE = 'piece',
  KILOGRAM = 'kilogram',
  GRAM = 'gram',
  LITER = 'liter',
  MILLILITER = 'milliliter',
  PACKAGE = 'package',
  BOTTLE = 'bottle',
  BOX = 'box',
  BAG = 'bag',
  CAN = 'can',
  JAR = 'jar',
  DOZEN = 'dozen',
  BUNCH = 'bunch'
}

export type CallStatusResponse = {
  call_id: string;
  status: CallStatus;
  items?: Array<OrderItem>;
  livekit_url?: string | null;
  livekit_token?: string | null;
};

export type HTTPValidationError = {
  detail?: Array<ValidationError>;
};

export type OrderItem = {
  product: string;
  quantity?: number;
  unit?: Unit;
};

export type ReportStatusRequest = {
  status: CallStatus;
  items?: Array<OrderItem>;
};

export type StartCallRequest = {
  mode?: CallMode;
  phone_number?: string | null;
  language?: Language;
};

export type ValidationError = {
  loc: Array<string | number>;
  msg: string;
  type: string;
};

export type StartCallV1CallsPostData = {
  body: StartCallRequest;
};

export type StartCallV1CallsPostResponse = CallStatusResponse;

export type StartCallV1CallsPostError = HTTPValidationError;

export type GetCallV1CallsCallIdGetData = {
  path: {
    call_id: string;
  };
};

export type GetCallV1CallsCallIdGetResponse = CallStatusResponse;

export type GetCallV1CallsCallIdGetError = HTTPValidationError;

export type ReportCallStatusV1CallsCallIdStatusPostData = {
  body: ReportStatusRequest;
  headers: {
    'x-internal-secret': string;
  };
  path: {
    call_id: string;
  };
};

export type ReportCallStatusV1CallsCallIdStatusPostResponse = {
  [key: string]: unknown;
};

export type ReportCallStatusV1CallsCallIdStatusPostError = HTTPValidationError;
